var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompletedBackground(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 552.017,
    height: 382.122,
    viewBox: "0 0 552.017 382.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5043",
    "data-name": "Group 5043",
    transform: "translate(-385.336 -187.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5034",
    "data-name": "Group 5034",
    transform: "translate(407 -48.5)",
    opacity: 0.824
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_93",
    "data-name": "Line 93",
    d: "M1.5,27h-3V0h3Z",
    transform: "translate(452.307 475)",
    fill: "#58ab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_94",
    "data-name": "Line 94",
    d: "M26.386,1.5H0v-3H26.386Z",
    transform: "translate(438.807 488.5)",
    fill: "#58ab27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5042",
    "data-name": "Group 5042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5031",
    "data-name": "Group 5031",
    transform: "translate(3.94 19)",
    opacity: 0.843
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_93-2",
    "data-name": "Line 93",
    d: "M1.5,27h-3V0h3Z",
    transform: "translate(452.307 475)",
    fill: "#58ab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_94-2",
    "data-name": "Line 94",
    d: "M26.386,1.5H0v-3H26.386Z",
    transform: "translate(438.807 488.5)",
    fill: "#58ab27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5032",
    "data-name": "Group 5032",
    transform: "translate(42.856 -43.354)",
    opacity: 0.211
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_93-3",
    "data-name": "Line 93",
    d: "M1.5,27h-3V0h3Z",
    transform: "translate(452.307 475)",
    fill: "#58ab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_94-3",
    "data-name": "Line 94",
    d: "M26.386,1.5H0v-3H26.386Z",
    transform: "translate(438.807 488.5)",
    fill: "#58ab27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5035",
    "data-name": "Group 5035",
    transform: "translate(472.16 -8)",
    opacity: 0.211
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_93-4",
    "data-name": "Line 93",
    d: "M1.5,27h-3V0h3Z",
    transform: "translate(452.307 475)",
    fill: "#58ab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_94-4",
    "data-name": "Line 94",
    d: "M26.386,1.5H0v-3H26.386Z",
    transform: "translate(438.807 488.5)",
    fill: "#58ab27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5033",
    "data-name": "Group 5033",
    transform: "translate(-25.387 -33.061)",
    opacity: 0.211
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_93-5",
    "data-name": "Line 93",
    d: "M.356,16.707H-1.5V0H.356Z",
    transform: "translate(447.732 475)",
    fill: "#58ab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_94-5",
    "data-name": "Line 94",
    d: "M16.328.356H0V-1.5H16.328Z",
    transform: "translate(438.807 483.925)",
    fill: "#58ab27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5038",
    "data-name": "Group 5038",
    transform: "translate(22.164 -84.707)",
    opacity: 0.591
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_93-6",
    "data-name": "Line 93",
    d: "M.356,16.707H-1.5V0H.356Z",
    transform: "translate(447.732 475)",
    fill: "#58ab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_94-6",
    "data-name": "Line 94",
    d: "M16.328.356H0V-1.5H16.328Z",
    transform: "translate(438.807 483.925)",
    fill: "#58ab27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5039",
    "data-name": "Group 5039",
    transform: "translate(-53.471 -287.707)",
    opacity: 0.348
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_93-7",
    "data-name": "Line 93",
    d: "M.356,16.707H-1.5V0H.356Z",
    transform: "translate(447.732 475)",
    fill: "#58ab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_94-7",
    "data-name": "Line 94",
    d: "M16.328.356H0V-1.5H16.328Z",
    transform: "translate(438.807 483.925)",
    fill: "#58ab27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5036",
    "data-name": "Group 5036",
    transform: "translate(463.996 -54.915)",
    opacity: 0.452
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_93-8",
    "data-name": "Line 93",
    d: "M.356,16.707H-1.5V0H.356Z",
    transform: "translate(447.732 475)",
    fill: "#58ab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_94-8",
    "data-name": "Line 94",
    d: "M16.328.356H0V-1.5H16.328Z",
    transform: "translate(438.807 483.925)",
    fill: "#58ab27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5037",
    "data-name": "Group 5037",
    transform: "translate(447.669 -219)",
    opacity: 0.416
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_93-9",
    "data-name": "Line 93",
    d: "M.356,16.707H-1.5V0H.356Z",
    transform: "translate(447.732 475)",
    fill: "#58ab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_94-9",
    "data-name": "Line 94",
    d: "M16.328.356H0V-1.5H16.328Z",
    transform: "translate(438.807 483.925)",
    fill: "#58ab27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5040",
    "data-name": "Group 5040",
    transform: "translate(425.223 61)",
    opacity: 0.411
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_93-10",
    "data-name": "Line 93",
    d: "M.356,16.707H-1.5V0H.356Z",
    transform: "translate(447.732 475)",
    fill: "#58ab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_94-10",
    "data-name": "Line 94",
    d: "M16.328.356H0V-1.5H16.328Z",
    transform: "translate(438.807 483.925)",
    fill: "#58ab27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5041",
    "data-name": "Group 5041",
    transform: "translate(75.223 77.707)",
    opacity: 0.211
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_93-11",
    "data-name": "Line 93",
    d: "M.356,16.707H-1.5V0H.356Z",
    transform: "translate(447.732 475)",
    fill: "#58ab27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_94-11",
    "data-name": "Line 94",
    d: "M16.328.356H0V-1.5H16.328Z",
    transform: "translate(438.807 483.925)",
    fill: "#58ab27"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedBackground);
export default __webpack_public_path__ + "static/media/completed-background.dde8100b6a511654842d528f12f4049a.svg";
export { ForwardRef as ReactComponent };